const showMessage = type => message => {
  document.querySelector('.dc-flash-wrapper').classList.add('dc-is-visible');
  document.querySelector('.dc-flash').classList.add(`dc-flash--${type}`);
  document.querySelector('.dc-flash__content').innerHTML = message;
};

export const clearFlash = () => {
  document.querySelector('.dc-flash-wrapper').classList.remove('dc-is-visible');
  document
    .querySelector('.dc-flash')
    .classList.remove(
      'dc-flash--error',
      'dc-flash--success',
      'dc-flash--warning'
    );
  document.querySelector('.dc-flash__content').innerHTML = '';
};

export const showSuccessFlash = showMessage('success');
export const showErrorFlash = showMessage('error');
export const showWarningFlash = showMessage('notice');
